export const BlipTo = {
  ANALYTICS: "postmaster@analytics.msging.net",
  MESSAGING: "postmaster@msging.net",
  MESSAGING_WA: "postmaster@wa.gw.msging.net",
  MEDIA: "postmaster@media.msging.net",
  ACTIVE_CAMPAIGN: "postmaster@activecampaign.msging.net",
  BUILDER: "postmaster@builder.msging.net",
} as const;
